import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { postDataRequestPublic } from '../../common/commonfunctions';
import config from '../../config';
import { Divider, Paper, TextField, Grid, Box, Typography, Button } from '@material-ui/core';
import useStyle from './style.js';
import { LeadRequest, UpdateLeadRequest } from './LeadFinderMutation';
import { LoadingPage } from '../LoadingPage/LoadingPage';
import { UploadImage } from '../../Api Mutation/InquiryForm';
import ApolloClient from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { createUploadLink } from 'apollo-upload-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { showNotification } from '../../components/Notification/ToastifyNotifications.js';

const publicheaders = {
  'Content-Type': 'application/json',
  Authorization: config?.staticToken,
  'Apollo-Require-Preflight': 'true',
};

const httpLink = createUploadLink({
  uri: config.contactApi,
  headers: publicheaders,
});

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: publicheaders,
  });

  return forward(operation);
});

const client = new ApolloClient({
  link: authMiddleware.concat(httpLink),
  cache: new InMemoryCache(),
});

const LeadFinderPublicPage = () => {
  const {
    requestid,
  } = useParams([]);
  const classes = useStyle();
  const [leadData, setLeadData] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [files, setFiles] = useState([]);

  const getData = () => {
    if (requestid) {
      setDataLoading(true);
      postDataRequestPublic(config.emailFinderApi, {
        query: LeadRequest,
        variables: {
          requestid,
        },
      }).then((res) => {
        setLeadData(res?.data?.leadFinderRequestbyid);
        setDataLoading(false);
      });
    }
  }

  useEffect(() => {
    getData();
  }, [requestid]);

  return (
    <div className={classes.paper}>
      {dataLoading && (<LoadingPage />)}
      <Paper className={classes.cal} style={{ border: '1px solid lightgrey', margin: '5rem auto' }} elevation={6}>
        <Box mb={1}>
          <Typography variant='h5'>File Upload For Leads</Typography>
        </Box>
        <Divider />
        <Grid container spacing={2} style={{ marginTop: 3 }}>
          <Grid item xs={12} md={8} lg={8}>
            <TextField
              type="text"
              variant="outlined"
              size="small"
              label="Request ID"
              disabled
              fullWidth
              value={leadData?.requestno || ''}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <TextField
              type="text"
              variant="outlined"
              size="small"
              label="Lead Count"
              disabled
              fullWidth
              value={leadData?.leadcount || ''}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Box className={classes.Dropzone}>
              <Dropzone
                onDrop={async acceptedFiles => {
                  setDataLoading(true);
                  const res = await client.mutate(
                    {
                      mutation: UploadImage,
                      variables: {
                        images: acceptedFiles,
                      },
                    }
                  );
                  if (
                    res?.data?.uploadimg
                      ?.images
                  ) {
                    setFiles([res.data.uploadimg.images]);
                    setDataLoading(false);
                    showNotification(
                      'Image uploaded successfully',
                      'success'
                    );
                  }
                }}
              >
                {({
                  getRootProps,
                  getInputProps,
                }) => (
                  <div
                    {...getRootProps({
                      className:
                        'dropzone',
                    })}
                  >
                    <input
                      {...getInputProps()}
                    />
                    <CloudUploadIcon
                      className={
                        classes.placeholderIcon
                      }
                    />
                    <br />
                    <p>
                      Upload File
                    </p>
                  </div>
                )}
              </Dropzone>
              <center>
                <Typography variant="body2">
                  {' '}
                  *File size should not
                  greater than 30MB!
                </Typography>
              </center>
            </Box>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            sm={12}
          >
            <Button
              variant="contained"
              size="medium"
              color="primary"
              style={{ float: 'right' }}
              disabled={leadData?.iscompleted || files.length === 0}
              onClick={() => {
                setDataLoading(true);
                postDataRequestPublic(config.emailFinderApi, {
                  query: UpdateLeadRequest,
                  variables: {
                    requestid,
                    files: JSON.stringify(files),
                  },
                }).then((res) => {
                  showNotification('Request updated successfully', 'success');
                  getData();
                  setDataLoading(false);
                });
              }}
            >
              Update Request
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </div>
  )
}

export default LeadFinderPublicPage